







































































import { Component, Prop, Provide } from 'vue-property-decorator';

import MixinDialog from '../../../../plugins/podolib/services/helper/mixins/dialog';

import {
  StepConditions,
  ConditionsWalkingAidDevices,
} from '@/components/analysis/steps/conditions/AnalysisStepConditions';
import { Severity } from '@sentry/types';
import ElementBgIcon from '@/components/elements/ElementBgIcon.vue';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition } from '@/plugins/podolib/services/entities/EntityPatients';
@Component({
  components: { ElementBgIcon },
})
export default class AnalysisStepConditionsWalkingAidsDialog extends MixinDialog {
  @Prop({ required: true }) private walking_aids!: StepConditions['walking_aids'];
  @Prop({ required: false, default: null }) private acquisitionId!: TEntity<TAcquisition>['_id'];
  @Prop({ required: false, default: false }) private editResults!: boolean;

  @Provide() mode: 'add' | 'edit' | null = null;

  internalWalkingAids: StepConditions['walking_aids'] = [];

  pending = false;
  error: Error | null = null;
  success = false;

  get items() {
    return this.$pdc.helper!.enumToArrayAndTranslate(ConditionsWalkingAidDevices, {
      key: 'analysis.steps.conditions.walking_aids',
    });
  }

  get iconsKeyVersion() {
    return [
      {
        id: 'simple-cane',
        key: '7PHUs5ZTXFdsKrErOMe0KETgoLroyqw1',
      },
      {
        id: 'english-cane',
        key: 'M.ulFIMkEpt1UKIYW8vZYmhAAcBNSHQE',
      },
      {
        id: 'english-cane-2',
        key: 'JmiiI2HY2bUnu4DF7HTM9A2GRtW3b36D',
      },
      {
        id: 'rollator',
        key: 'JneabHRx0k1XlPM7laah8dSjvLVbnGHv',
      },
      {
        id: 'walker',
        key: 'K.HdcYb_Y.4n1VX3N.Hl3Qr2uFOKFQzN',
      },
      {
        id: 'lift-and-orthopaedic-shoes',
        key: '.nkWmeslDrhh9XT5gGlzF2Rv9EJ9IhUj',
      },
      {
        id: 'other',
        key: 'Q63Jba_fR9ICPSms6L4WUrvWY82G70I8',
      },
    ];
  }

  getIconFromKey(id: string) {
    return this.iconsKeyVersion.find((x: any) => x.id == id)!.key;
  }

  _open(mode: 'add' | 'edit', index?: number) {
    this.mode = mode;
    this.internalWalkingAids = Object.assign([], this.walking_aids);

    this.open();
  }
  _close() {
    this.close();
  }

  save() {
    return this.setWalkingAids();
  }
  // Edit data in analysis mode
  async setWalkingAids() {
    try {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      // Reset flags
      this.success = false;
      this.error = null;
      // Set 'pending' flag
      this.pending = true;

      if (!this.editResults) {
        this.$emit('update:walking_aids', this.internalWalkingAids);
      } else {
        this.$pdc.repository?.patchRessource({
          ressource: 'acquisitions',
          params: {
            _id: this.acquisitionId,
          },
          data: {
            $set: {
              'conditions.walking_aids': this.internalWalkingAids,
            },
          },
        });
      }

      this._close();
    } catch (e) {
      // Set 'error' flag
      this.error = e;
      // Sentry
      this.$sentry.captureMessage(e.message, Severity.Error);
    } finally {
      // Reset 'pending' flag
      this.pending = false;
    }
  }
}
